/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { getSearchColors } from "../component/APIS";
import MultiRangeSlider from "./multiRangeSlider/MultiRangeSlider";
import debounce from "debounce";
import { getPrice, getPriceSymbole, getPriceCurrencyCode } from "../Helper";

const FilterBar = ({ price, setClearDrop }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const { categorySlug, subCategorySlug } = useParams();
  const searchCol = params.get("colors");
  const searchCat = params.get("category_product");
  //console.log(searchCat)
  const searchShip = params.get("shipping");
  const searchPrice = params.get("priceRange");
  const searchRTS = params.get("rts");
  const searchMTORTS = params.get("mtorts");

  const [filter, setFilter] = useState({
    slug: searchCat ? searchCat.split("_") : [],
    res: searchCat ? searchCat.split("_") : [],
  });
  //console.log(filter,searchCat)
  const [colorFilter, setColorFilter] = useState({
    colorSlug: searchCol ? searchCol.split("_") : [],
    colorRes: searchCol ? searchCol.split("_") : [],
  });

  const [shipFilter, setShipFilter] = useState({
    shipSlug: searchShip ? searchShip.split("_") : [],
    shipRes: searchShip ? searchShip.split("_") : [],
  });

  /* const [shipRTS, setShipRTS] = useState({
    shipSlug: searchRTS ? searchRTS.split("_") : [],
    shipRes: searchRTS ? searchRTS.split("_") : [],
  }); */
  const searchMTO = params.get("mtorts");

  const [shipRTS, setShipRTS] = useState({
    rts: searchRTS === "1",
    mtorts: searchMTORTS === "1",
  });

  const [priceFilter, setPriceFilter] = useState({
    priceMinSlug: searchPrice ? searchPrice.split("-")[0] : [],
    priceMinRes: searchPrice ? searchPrice.split("-")[0] : [],
    priceMaxSlug: searchPrice ? searchPrice.split("-")[1] : [],
    priceMaxRes: searchPrice ? searchPrice.split("-")[1] : [],
  });

  const [searchParams, setSearchParams] = useSearchParams({});

  const handleClick = (e) => {
    const { value, checked } = e.target;
    const { slug } = filter;

    let updatedSlug = [...slug];

    const category = getcolor.categories.find((cat) => cat.slug === value);

    // Parent Category
    if (category) {
      // Always keep parent open
      setActiveTab(category.name.replace(/\s/g, ""));

      if (checked) {
        updatedSlug = [
          ...new Set([
            ...updatedSlug,
            category.slug,
            ...category.childes.map((sub) => sub.slug),
          ]),
        ];
      } else {
        updatedSlug = updatedSlug.filter(
          (item) =>
            item !== category.slug &&
            !category.childes.map((sub) => sub.slug).includes(item),
        );
      }
    } else {
      // Child Category
      const parentCategory = getcolor.categories.find((cat) =>
        cat.childes.some((sub) => sub.slug === value),
      );

      if (parentCategory) {
        // Always keep parent open
        setActiveTab(parentCategory.name.replace(/\s/g, ""));
      }

      if (checked) {
        updatedSlug.push(value);

        if (parentCategory) {
          const allSubChecked = parentCategory.childes.every((sub) =>
            updatedSlug.includes(sub.slug),
          );

          if (allSubChecked) {
            updatedSlug.push(parentCategory.slug);
          }
        }
      } else {
        updatedSlug = updatedSlug.filter((item) => item !== value);

        if (parentCategory) {
          updatedSlug = updatedSlug.filter(
            (item) => item !== parentCategory.slug,
          );
        }
      }
    }

    setFilter({
      slug: [...new Set(updatedSlug)],
      res: [...new Set(updatedSlug)],
    });

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  //Handle Click Color
  const handleClickColor = (e) => {
    const { value, checked } = e.target;
    const { colorSlug } = colorFilter;
    if (checked) {
      setColorFilter({
        colorSlug: [...colorSlug, value],
        colorRes: [...colorSlug, value],
      });
    } else {
      setColorFilter({
        colorSlug: colorSlug.filter((e) => e !== value),
        colorRes: colorSlug.filter((e) => e !== value),
      });
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  //Handle Click Shipping
  const handleClickShipping = (e) => {
    const { value, checked } = e.target;
    const { shipSlug } = shipFilter;
    if (checked) {
      setShipFilter({
        shipSlug: [...shipSlug, value],
        shipRes: [...shipSlug, value],
      });
    } else {
      setShipFilter({
        shipSlug: shipSlug.filter((e) => e !== value),
        shipRes: shipSlug.filter((e) => e !== value),
      });
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleClickRTSMTO = (e) => {
    const { value } = e.target;

    setShipRTS({
      rts: value === "rts",
      mtorts: value === "mtorts",
    });

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    setSearchParams((searchParams) => {
      if (searchParams) {
        if (filter.res.length > 0) {
          searchParams.set("category_product", filter.res.join("_"));
        } else {
          searchParams.delete("category_product");
        }
        if (colorFilter.colorRes.length > 0) {
          searchParams.set("colors", colorFilter.colorRes.join("_"));
        } else {
          searchParams.delete("colors");
        }
        if (shipFilter.shipRes.length > 0) {
          searchParams.set("shipping", shipFilter.shipRes.join("_"));
        } else {
          searchParams.delete("shipping");
        }

        /* if (shipRTS.shipRes.length > 0) {
          searchParams.set("rts", 1);
        } else {
          searchParams.delete("rts");
        } */

        if (shipRTS.rts) {
          searchParams.set("rts", "1");
        } else {
          searchParams.delete("rts");
        }

        if (shipRTS.mtorts) {
          searchParams.set("mtorts", "1");
        } else {
          searchParams.delete("mtorts");
        }

        if (
          priceFilter.priceMinRes.length > 0 &&
          priceFilter.priceMaxRes.length > 0
        ) {
          searchParams.set(
            "priceRange",
            priceFilter.priceMinRes + "-" + priceFilter.priceMaxRes,
          );
          searchParams.set("currencyCode", getPriceCurrencyCode());
        } else {
          searchParams.delete("priceRange");
          searchParams.delete("currencyCode");
        }
        searchParams.set("orderBy", price);
        return searchParams;
      }
    });
    //eslint-disable-next-line
  }, [
    filter.res,
    colorFilter.colorRes,
    shipFilter.shipRes,
    priceFilter.priceMinRes,
    priceFilter.priceMaxRes,
    shipRTS.rts,
    shipRTS.mtorts,
  ]);

  const [getcolor, setGetcolor] = useState([]);
  const [minVal, setMin] = useState(0);
  const [maxVal, setMax] = useState(0);
  const colorData = async () => {
    try {
      let data = await getSearchColors();
      setMin(data?.prices?.minPrice);
      setMax(data?.prices?.maxPrice);
      setGetcolor(data);
    } catch (error) {
      throw error;
    }
  };
  useEffect(() => {
    colorData();
    //eslint-disable-next-line
  }, []);

  const handlePriceChange = debounce((minValue, maxValue) => {
    setPriceFilter({
      priceMinSlug: [minValue],
      priceMinRes: [minValue],
      priceMaxSlug: [maxValue],
      priceMaxRes: [maxValue],
    });
  }, 500);

  const [activeTab, setActiveTab] = useState(null);
  const [reset, setReset] = useState(false);
  const handleTabClick = (dataId) => {
    //setActiveTab(dataId);
    //console.log(dataId)
    setActiveTab(activeTab === dataId ? null : dataId);
  };

  useEffect(() => {
    setFilter({
      slug: searchCat ? searchCat.split("_") : [],
      res: searchCat ? searchCat.split("_") : [],
    });
    setColorFilter({
      colorSlug: searchCol ? searchCol.split("_") : [],
      colorRes: searchCol ? searchCol.split("_") : [],
    });
    setShipFilter({
      shipSlug: searchShip ? searchShip.split("_") : [],
      shipRes: searchShip ? searchShip.split("_") : [],
    });
    /*  setShipRTS({
       shipSlug: searchRTS ? searchRTS.split("_") : [],
       shipRes: searchRTS ? searchRTS.split("_") : [],
     }); */
    setShipRTS({
      rts: searchRTS === "1",
      mtorts: searchMTORTS === "1",
    });
    setPriceFilter({
      priceMinSlug: searchPrice ? searchPrice.split("-")[0] : [],
      priceMinRes: searchPrice ? searchPrice.split("-")[0] : [],
      priceMaxSlug: searchPrice ? searchPrice.split("-")[1] : [],
      priceMaxRes: searchPrice ? searchPrice.split("-")[1] : [],
    });
    setMin(minVal);
    setMax(maxVal);
    if (searchCat?.includes("lehengas")) {
      setActiveTab("Lehengas");
    } else if (searchCat?.includes("gowns")) {
      setActiveTab("Gowns");
    } else if (searchCat?.includes("indo-westerns")) {
      setActiveTab("IndoWesterns");
    } else {
      //setActiveTab(null);
    }
  }, [searchCat, searchCol, searchShip, searchPrice, minVal, maxVal]);

  const handleClearFilter = (minVal, maxVal) => {
    setFilter({
      slug: [],
      res: [],
    });

    setColorFilter({
      colorSlug: [],
      colorRes: [],
    });

    setShipFilter({
      shipSlug: [],
      shipRes: [],
    });

    setPriceFilter({
      priceMinSlug: [],
      priceMinRes: [],
      priceMaxSlug: [],
      priceMaxRes: [],
    });

    setMin(minVal);
    setMax(maxVal);

    searchParams.set("orderBy", "default");
    setClearDrop("Default");
    setReset(true);
    setTimeout(() => setReset(false), 500);
  };

  useEffect(() => {
    setSearchParams(() => {
      searchParams.set("orderBy", price);
      return searchParams;
    });
  }, [price]);

  return (
    <div className="category-bar">
      <div className="category-wrap category-menu">
        <h2>Pret</h2>
        {getcolor?.categories && (
          <ul>
            {getcolor.categories
              .filter((cat) => cat.category_type === 2)
              .map((cat, i) => (
                <li
                  key={cat.id}
                  id={cat.name.replace(/\s/g, "")}
                  className={
                    activeTab === cat.name.replace(/\s/g, "") ||
                      filter.slug.includes(cat.slug) ||
                      cat.childes.some((sub) => filter.slug.includes(sub.slug))
                      ? "active"
                      : ""
                  }
                >
                  <label>
                    <input
                      type="checkbox"
                      value={cat.slug}
                      name="filter"
                      onClick={handleClick}
                      checked={
                        searchCat ? filter.res.includes(cat.slug) : false
                      }
                    />
                    {cat.name}
                  </label>

                  {cat.childes.length > 0 && (
                    <>
                      <span
                        className={
                          activeTab === cat.name.replace(/\s/g, "")
                            ? "has-submenu active"
                            : "has-submenu"
                        }
                        data-id={cat.name.replace(/\s/g, "")}
                        onClick={() =>
                          handleTabClick(cat.name.replace(/\s/g, ""))
                        }
                      >
                        <i className="fa-solid fa-angle-down"></i>
                      </span>

                      <ul>
                        {cat.childes.map((catCh) => (
                          <li key={catCh.id} id={catCh.name.replace(/\s/g, "")}>
                            <label>
                              <input
                                type="checkbox"
                                value={catCh.slug}
                                name="filter"
                                onClick={handleClick}
                                checked={
                                  searchCat
                                    ? filter.res.includes(catCh.slug)
                                    : false
                                }
                              />
                              {catCh.name}
                            </label>
                          </li>
                        ))}
                      </ul>
                    </>
                  )}
                </li>
              ))}
          </ul>
        )}
      </div>
      <div className="category-wrap category-menu category-menu-couture">
        <h2>Couture</h2>
        {getcolor?.categories && (
          <ul>
            {getcolor.categories
              .filter((cat) => cat.category_type === 1)
              .map((cat, i) => (
                <li
                  key={cat.id}
                  id={cat.name.replace(/\s/g, "")}
                  className={
                    activeTab === cat.name.replace(/\s/g, "") ||
                      filter.slug.includes(cat.slug) ||
                      cat.childes.some((sub) => filter.slug.includes(sub.slug))
                      ? "active"
                      : ""
                  }
                >
                  <label>
                    <input
                      type="checkbox"
                      value={cat.slug}
                      name="filter"
                      onClick={handleClick}
                      checked={
                        searchCat ? filter.res.includes(cat.slug) : false
                      }
                    />
                    {cat.name}
                  </label>

                  {cat.childes.length > 0 && (
                    <>
                      <span
                        className={
                          activeTab === cat.name.replace(/\s/g, "")
                            ? "has-submenu active"
                            : "has-submenu"
                        }
                        data-id={cat.name.replace(/\s/g, "")}
                        onClick={() =>
                          handleTabClick(cat.name.replace(/\s/g, ""))
                        }
                      >
                        <i className="fa-solid fa-angle-down"></i>
                      </span>

                      <ul>
                        {cat.childes.map((catCh) => (
                          <li key={catCh.id} id={catCh.name.replace(/\s/g, "")}>
                            <label>
                              <input
                                type="checkbox"
                                value={catCh.slug}
                                name="filter"
                                onClick={handleClick}
                                checked={
                                  searchCat
                                    ? filter.res.includes(catCh.slug)
                                    : false
                                }
                              />
                              {catCh.name}
                            </label>
                          </li>
                        ))}
                      </ul>
                    </>
                  )}
                </li>
              ))}
          </ul>
        )}
      </div>
      <div className="category-wrap">
        <h2 className="shipping-time-heading">
          <i className="fa-solid fa-truck"></i> Shipping Time
        </h2>
        {/* {getcolor?.shipping_time && (
          <ul>
            {getcolor?.shipping_time &&
              getcolor?.shipping_time.map((ship, p) => (
                <li key={p}>
                  <label>
                    <input
                      type="checkbox"
                      value={ship.shipping_time}
                      name="shipping_time"
                      onClick={handleClickShipping}
                      checked={
                        searchShip
                          ? shipFilter.shipRes.includes(ship.shipping_time)
                          : 0
                      }
                    />
                    {ship.shipping_time}
                  </label>
                </li>
              ))}
          </ul>
        )} */}
        {getcolor?.rts_mto && (
          <ul>
            {getcolor?.rts_mto &&
              getcolor?.rts_mto.map((rtsmto, p) => (
                <li key={p}>
                  <label>
                    <input
                      type="radio"
                      value={rtsmto?.value}
                      name="rts_mto"
                      onClick={handleClickRTSMTO}
                      /* checked={
                        searchRTS
                          ? shipRTS.shipRes.includes(rtsmto?.value)
                          : 0
                      } */
                      checked={shipRTS[rtsmto?.value] || false}
                    />
                    {rtsmto?.name}
                    <p className="shipping-time-desc">{rtsmto?.message}</p>
                  </label>
                </li>
              ))}
          </ul>
        )}
      </div>
      <div className="category-wrap color-box">
        <h2>Color</h2>
        <ul>
          {getcolor.colors &&
            getcolor.colors.map((t, k) => (
              <li key={k}>
                <label>
                  <input
                    type="checkbox"
                    value={t.colors.replace(/#/g, "")}
                    name="color"
                    onClick={handleClickColor}
                    checked={
                      searchCol
                        ? colorFilter.colorRes.includes(
                          t.colors.replace(/#/g, ""),
                        )
                        : 0
                    }
                  />
                  <span
                    className="color-box"
                    style={{ backgroundColor: `${t.colors}` }}
                    title={t.colors_name}
                  ></span>
                  <span className="color-name">{t.colors_name}</span>
                </label>
              </li>
            ))}
        </ul>
      </div>
      {getcolor?.prices && (
        <div className="category-wrap rangeslider-box">
          <h2 className="d-flex justify-content-between flex-row">
            Price
            <span
              className="clearfilter cursor"
              onClick={() => handleClearFilter(minVal, maxVal)}
            >
              Clear Filter
            </span>
          </h2>
          <MultiRangeSlider
            min={getPrice(minVal, false)}
            max={getPrice(maxVal, false)}
            currencySymbol={getPriceSymbole()}
            handlePriceChange={handlePriceChange}
            reset={reset}
          />
        </div>
      )}
    </div>
  );
};

export default FilterBar;
